import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';

import Translations from 'Languages/translations';

const Locale = 'pt';
const defaultLocale = 'pt';

const ProviderLanguage = ({ children }) => (
  <IntlProvider
    locale={Locale}
    key={Locale}
    defaultLocale={defaultLocale}
    messages={Translations[Locale]}
  >
    { children }
  </IntlProvider>
);

ProviderLanguage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default (ProviderLanguage);
